// extracted by mini-css-extract-plugin
export default {"modal":"UploadModal_modal__jO2ns"};